module.exports = __webpack_public_path__ + "static/media/moon-stars.a03a7d47.svg";